import { IcoChevronRight } from "assets/icons";

import IcoWhatsapp from "assets/icons/ico-whatsapp";
import { ModalAbout } from "components/Modal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPartnerUuid, logout } from "services/auth";
import { getPartner } from "services/partner";
import { RootState } from "store";
import styles from "./styles.module.scss";

export default function ProfilePage() {
	const navigate = useNavigate();
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [showAboutModal, setShowAboutModal] = useState(false);

	const { logged_user } = useSelector((state: RootState) => state.tokens);

	const fetchData = async () => {
		if (!logged_user) return;

		const partnerUuid = (await getPartnerUuid()) || "";
		const partner: any = await getPartner(partnerUuid);

		setName(partner.name);
		setEmail(logged_user.email);
	};

	useEffect(() => {
		fetchData();
	}, []);

	const handleLogout = async () => {
		await logout();
		navigate("/login", { replace: true });
	};

	const openUseTerms = () => {
		window.open("/XX_VANBORA contrato empresas_6-.pdf", "_blank", "noreferrer");
	};

	const openPrivacyPolicy = () => {
		window.open("/XX_VANBORA contrato empresas_6-.pdf", "_blank", "noreferrer");
	};

	return (
		<div className={styles.container}>
			<ModalAbout
				open={showAboutModal}
				onClose={() => setShowAboutModal(false)}
			/>

			<div className={styles.profileHeader}>
				<span>Perfil</span>
			</div>
			<div className={styles.userProfile}>
				<span>{name}</span>
				<span>{email}</span>
			</div>
			<div className={styles.profileContent}>
				<div className="w-full">
					<div
						className={styles.profileItem}
						onClick={() => navigate("/cadastro/informacoes-pessoais")}
					>
						<span>Dados Pessoais</span>
						<IcoChevronRight />
					</div>
					<div
						className={styles.profileItem}
						onClick={() => navigate("/alterar-senha")}
					>
						<span>Alterar a senha</span>
						<IcoChevronRight />
					</div>
					<div
						className={styles.profileItem}
						onClick={() => navigate("/cadastro/veiculos")}
					>
						<div className="flex flex-col w-full">
							<span>Veículos</span>
							{/*
							<span>15 veículos cadastrados</span>
							*/}
						</div>
						<IcoChevronRight />
					</div>
					<div
						className={styles.profileItem}
						onClick={() => navigate("/cadastro/motoristas")}
					>
						<div className="flex flex-col w-full">
							<span>Motoristas</span>
							{/*
							<span>14 motoristas cadastrados</span>
							*/}
						</div>
						<IcoChevronRight />
					</div>
					<div
						className={styles.profileItem}
						onClick={() => navigate("/cadastro/contas")}
					>
						<span>Dados de Pagamento</span>
						<IcoChevronRight />
					</div>
				</div>
				<div className="w-full">
					<div
						className={styles.profileItem}
						onClick={() => setShowAboutModal(true)}
					>
						<span>Sobre a VANbora</span>
						<IcoChevronRight />
					</div>
					<div className={styles.profileItem} onClick={() => openUseTerms()}>
						<span>Termos e Condições de Uso</span>
						<IcoChevronRight />
					</div>
					<div
						className={styles.profileItem}
						onClick={() => openPrivacyPolicy()}
					>
						<span>Política de Privacidade</span>
						<IcoChevronRight />
					</div>
					<div
						className={styles.doubtsCard}
						onClick={() => window.open("https://wa.me/5511921117878", "_blank")}
						style={{ cursor: "pointer" }}
					>
						<div className={styles.doubtsContent}>
							<div className={styles.doubtsIcon}>
								<IcoWhatsapp width="40" height="40" />
							</div>
							<div>
								<span className={styles.doubtsTitle}>
									Dúvidas? Fale com a gente
								</span>
								<span className={styles.doubtsText}>
									Em caso de dúvidas ou cancelamento de viagens, entre em
									contato.
								</span>
							</div>
						</div>
						<IcoChevronRight />
					</div>
					<button
						type="button"
						className={styles.logoutButton}
						onClick={handleLogout}
					>
						Sair do Aplicativo
					</button>
					{/*
					<button
						type="button"
						className={styles.deleteAccountButton}
						onClick={() => {}}
					>
						encerrar conta no VANbora
					</button>
					*/}
				</div>
			</div>
		</div>
	);
}
